import * as amplitude from '@amplitude/analytics-browser'

const calculatePhantomShare = (
	options: {
		label: string
		value: string
		disabled: boolean
		badgeProps: { type: string; text: string } | undefined
	}[],
) => {
	const totalOptions = options.length
	const disabledOptions = options.filter(
		(option: { disabled: any }) => option.disabled,
	).length
	const phantomSharePercentage = (disabledOptions / totalOptions) * 100
	return phantomSharePercentage.toFixed(2) // Keep only two decimal places for cleanliness.
}

export const trackPdpViewed = (
	productData: any,
	activeStyle: any,
	selectedSku: string | null,
	amplitudePageSource: any,
	utmParams: any,
	sizeOptions: any,
	lastSentSkuRef: React.MutableRefObject<string>,
) => {
	if (productData && activeStyle) {
		const selectedVariant =
			activeStyle.variants.find(
				(variant: { sku: string | null }) => variant.sku === selectedSku,
			) || activeStyle.variants[0]

		if (selectedVariant.sku !== lastSentSkuRef.current) {
			const originalPrice =
				selectedVariant.prices && selectedVariant.prices.length > 0
					? selectedVariant.prices[0].value.centAmount / 100
					: 0 // Convert centAmount to standard currency format

			const discountedPrice = selectedVariant.lowestPrice?.discounted
				? selectedVariant.lowestPrice.discounted.value.centAmount / 100
				: originalPrice // Use discounted price if available, otherwise fallback to original price

			const discountPercentage =
				originalPrice > 0
					? ((originalPrice - discountedPrice) / originalPrice) * 100
					: 0 // Calculate discount percentage

			const phantomShare = calculatePhantomShare(sizeOptions)

			const isDiscounted = discountedPrice < originalPrice

			// Construct the event data
			const eventData = {
				sku: selectedVariant.sku,
				styleNumber: productData.productInfo.key,
				name: productData.productInfo.name.en,
				brand:
					selectedVariant.attributes?.find(
						(attr: { name: string }) => attr.name === 'brand',
					)?.value || '',
				color:
					selectedVariant.attributes?.find(
						(attr: { name: string }) => attr.name === 'color',
					)?.value.en || '',
				gender:
					selectedVariant.attributes?.find(
						(attr: { name: string }) => attr.name === 'gender',
					)?.value.en || '',
				age_group:
					selectedVariant.attributes?.find(
						(attr: { name: string }) => attr.name === 'age_group',
					)?.value || '',
				target_group:
					selectedVariant.attributes?.find(
						(attr: { name: string }) => attr.name === 'target_group',
					)?.value.en || '',
				price: discountedPrice,
				discountPercentage: discountPercentage.toFixed(2),
				isDiscounted: isDiscounted,
				phantomShare: phantomShare,
				page_source: amplitudePageSource, // Adapt this based on your needs
				...utmParams,
			}
			amplitude.track('PDP Viewed', eventData)
			lastSentSkuRef.current = selectedVariant.sku
		}
	}
}
